import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Listing from './Listing';
import SearchFilterArea from './SearchFilterArea';
import { axiosRequestStoreLocators, axiosRequestStoreRegions } from '../../actions/storeLocatorActions';
import { handleAxiosErrors } from '../../_utils';
import useManualReactTableState from '../ManualReactTableState';
import {
    convertDataToListingDisplay,
    convertStoreListingToAReadableFormat,
    convertStoreRegionsToAReadableFormat,
    getGraphQLTotalRecords,
} from '../../selectors/converterSelector';
import SectionPagination from '../SectionPagination';

function StoreLocator(props) {
    // State management
    // --------------------
    const mrtState = useManualReactTableState({
        listParams: {
            filters: {
                SingularName: 'Reseller',
                StoreLocator: true,
            },
            sortBy: 'BusinessName',
            sortDirection: 'ASC',
        },
    });

    const { isLoading, toggleLoading } = mrtState;
    const {
        list,
        listParams,
        getDisplayedList,
        setListDisplay,
        updateList,
    } = mrtState;
    const { getFilters, setFilters } = mrtState;
    const {
        getTotalRecords,
        setTotalRecords,
        getActivePage,
        setActivePage,
        getTotalPages,
        getPaginationPages,
    } = mrtState;
    const listEffectWatcher = mrtState.getEffectWatcher();

    // Effects
    // --------------------
    // - Main Request (one time)
    useEffect(() => {
        request();
    }, [listEffectWatcher]);

    // Functions
    // --------------------
    /**
     * Request List
     */
    const request = () => {
        toggleLoading('list', true);

        return axiosRequestStoreLocators(listParams)
            .then((response) => {
                const list = convertStoreListingToAReadableFormat(
                    response.data.data.readMembers
                );
                const listingDisplay = convertDataToListingDisplay(
                    response.data.data.readMembers,
                    'ID'
                );
                const total = getGraphQLTotalRecords(
                    response.data.data.readMembers
                );

                // wait for async requests
                Promise.all([
                    setListDisplay(listingDisplay),
                    updateList(list),
                    setTotalRecords(total),
                ]).then(() => {
                    toggleLoading('list', false);
                });
            })
            .catch((error) => {
                handleAxiosErrors(error);
                toggleLoading('list', false);
            });
    };

    /**
     * Set filter
     *
     * @param additionalFilterData
     */
    const applyFilter = (additionalFilterData) => {
        let updatedFilterData = {
            SingularName: 'Reseller',
            StoreLocator: true,
            ...getFilters(),
        };

        if (
            typeof additionalFilterData != 'undefined' &&
            additionalFilterData
        ) {
            updatedFilterData = {
                ...updatedFilterData,
                ...additionalFilterData,
            };
        }

        setActivePage(1);
        setFilters(updatedFilterData);
    };

    return (
        <React.Fragment>
            <SearchFilterArea
                isLoading={isLoading.list}
                handleFormSubmission={applyFilter}
            />
            <Listing isLoading={isLoading.list} list={getDisplayedList()} />
            <SectionPagination
                activePage={getActivePage()}
                totalPages={getTotalPages()}
                pages={getPaginationPages()}
                onPaginationClick={(pageNum) => setActivePage(pageNum)}
            />
        </React.Fragment>
    );
}

// default props
StoreLocator.defaultProps = {};
// validate props
StoreLocator.propTypes = {};

export default StoreLocator;
